import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateTable from "../../../../components/CreateTable";
import DropdownOptions from "../../../../constants/DropdownOptions";
import { getAllDestinationsList } from "../../../../modules/farmInformation/action";
import AllMainFarmSelectedDialog from "../../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../../Common/CheckAuthorization";
import Loader from "../../../Loader";

class DestinationsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        name: "Name",
        code: "Code"
      },
      order: "desc",
      orderBy: "id"
    };
  }
  componentDidMount() {
    const { getAllDestinationsList, selectedYear } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      getAllDestinationsList(selectedYear);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowDest &&
      this.props.rowDest !== nextProps.rowDest &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (this.props.MainFarmId !== nextProps.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
        this.props.getAllDestinationsList(this.props.selectedYear);
      }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
      this.props.getAllDestinationsList(nextProps.selectedYear);
    }
  }

  deleteRow = id => {
    //TODO: need to check if user should have the capablity to delete storage
  };

  editRow = id => {
    //TODO: Write action item for editing commodity-variety
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { headerRows, fetchingComplete, order, orderBy } = this.state;
    const { rowDest } = this.props;
    const prevPath = "farmsetup/farminformation",
      currentPage = "/onsite-storage";
    return (
      <div className="ticket-body">
        <div className="flex-display ticket-header">
          <h3 className="mainHeading">On site storage</h3>
        </div>
        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div>
              {fetchingComplete ? (
                <CreateTable
                  order={order}
                  orderBy={orderBy}
                  headerRows={headerRows}
                  rowData={rowDest}
                  delete={this.deleteRow}
                  //needs to be updated once edit is implemented
                  location={`${prevPath}${currentPage}`}
                  edit={this.editRow}
                  isMenuRequired={false}
                  onRequestSort={this.handleRequestSort}
                />
              ) : (
                <Loader />
              )}
            </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowDest: state.FarmInformationReducer.destinationsList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllDestinationsList }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DestinationsList);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/DestinationsList.js